import { render, staticRenderFns } from "./JobCard.vue?vue&type=template&id=3e680ddc&scoped=true"
import script from "./JobCard.vue?vue&type=script&lang=js"
export * from "./JobCard.vue?vue&type=script&lang=js"
import style0 from "./JobCard.vue?vue&type=style&index=0&id=3e680ddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e680ddc",
  null
  
)

export default component.exports